import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Account } from '../models/account.model';
import { environment } from 'src/environments/environment';
import * as globals from '../training/globals';

const baseUrl = `${environment.apis.connect}/${globals.ACCOUNTS}`;

@Injectable({
  providedIn: 'root',
})

export class AccountsService {
  constructor(
    private http: HttpClient) {
  }

  getAccounts(user_email: string): Observable<Account[]> {
    return this.http.get<Account[]>(`${baseUrl}/${globals.GET_ACCOUNTS}?${globals.USER_EMAIL}=${user_email}`);
  }

  getAccountsAll(): Observable<Account[]> {
    return this.http.get<Account[]>(`${baseUrl}/${globals.GET_ACCOUNTS_ALL}`);
  }

  getAccountsAvailable(user_email: string): Observable<Account[]> {
    return this.http.get<Account[]>(`${baseUrl}/${globals.GET_ACCOUNTS_AVAILABLE}?${globals.USER_EMAIL}=${user_email}`);
  }

  addOrUpdate(data: any): Observable<any> {
    return this.http.post<any>(`${baseUrl}/${globals.ADD_OR_UPDATE}`, data);
  }

  getAAT(id: number): Observable<string> {
    return this.http.get<string>(`${baseUrl}/${globals.GET_AAT}/${id}`);
  }

  isAccountUserAccess(user_email: string): Observable<boolean> {
    return this.http.get<boolean>(`${baseUrl}/${globals.IS_ACCOUNT_USER_ACCESS}?${globals.USER_EMAIL}=${user_email}`);
  }

  isAccountAccessToken(): Observable<boolean> {
    return this.http.get<boolean>(`${baseUrl}/${globals.IS_ACCOUNT_ACCESS_TOKEN}`);
  }

  getAccountsInUse(data: any): Observable<any> {
    return this.http.patch<any>(`${baseUrl}/${globals.ACCOUNTS_IN_USE}`, data);
  }

  getAccountsStudentsInUse(data: any): Observable<any> {
    return this.http.patch<any>(`${baseUrl}/${globals.ACCOUNTS_STUDENTS_IN_USE}`, data);
  }

  getAccountsStudentsAssign(data: any): Observable<any> {
    return this.http.patch<any>(`${baseUrl}/${globals.ACCOUNTS_STUDENTS_ASSIGN}`, data);
  }

  getAccountsFoldersInUse(data: any): Observable<string[]> {
    return this.http.patch<string[]>(`${baseUrl}/${globals.ACCOUNTS_FOLDERS_IN_USE}`, data);
  }

  updateAAT(data: any): Observable<boolean> {
    return this.http.post<boolean>(`${baseUrl}/${globals.UPDATE_AAT}`, data);
  }
}
